/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BalanceEdit_adminManagement$ref: FragmentReference;
declare export opaque type BalanceEdit_adminManagement$fragmentType: BalanceEdit_adminManagement$ref;
export type BalanceEdit_adminManagement = {|
  +manualBalanceChangeReasons: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +cuid: ?string,
        +key: ?string,
        +value: ?string,
        +createdAt: ?any,
      |}
    |}>
  |},
  +$refType: BalanceEdit_adminManagement$ref,
|};
export type BalanceEdit_adminManagement$data = BalanceEdit_adminManagement;
export type BalanceEdit_adminManagement$key = {
  +$data?: BalanceEdit_adminManagement$data,
  +$fragmentRefs: BalanceEdit_adminManagement$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BalanceEdit_adminManagement",
  "type": "AdminManagement",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "manualBalanceChangeReasons",
      "storageKey": null,
      "args": null,
      "concreteType": "AdminManagementManualBalanceChangeReasonConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "AdminManagementManualBalanceChangeReasonEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "AdminManagementManualBalanceChangeReason",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cuid",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "key",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "createdAt",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '914925316d3caed56de7ac75fbf992e5';
module.exports = node;
